import { assign } from 'lodash';

import * as api from 'api/api-personal';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saved: false,
  saveError: null,
  error: null,
  notFound: null,
  data: {},
  meta: {},
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saved: false,
  saveError: null,
  error: null,
  notFound: null,
};

const state = assign({}, initState);

const getters = {
  PersonalScheduledDateSchedules: state => state,
};

const actions = {
  GetPersonalScheduledDateSchedules({ commit }, query) {
    query = query || {};

    commit(types.GET_PERSONAL_SCHEDULED_DATE_SCHEDULES_START);
    api.getScheduledDateSchedules(
      query,
      (response) => {
        commit(types.GET_PERSONAL_SCHEDULED_DATE_SCHEDULES_SUCCESSFUL, { response });
      },
      (description, status, error) => {
        commit(types.GET_PERSONAL_SCHEDULED_DATE_SCHEDULES_ERROR, { error });
      },
    );
  },
  ClearPersonalScheduledDateSchedules({ commit }) {
    commit(types.CLEAR_PERSONAL_SCHEDULED_DATE_SCHEDULES_STORE);
  },
};

const mutations = {
  [types.GET_PERSONAL_SCHEDULED_DATE_SCHEDULES_START](state) {
    assign(state, neutralState, { fetching: true });
  },
  [types.GET_PERSONAL_SCHEDULED_DATE_SCHEDULES_ERROR](state, { error }) {
    assign(state, neutralState, { error });
  },
  [types.GET_PERSONAL_SCHEDULED_DATE_SCHEDULES_SUCCESSFUL](state, { response }) {
    assign(state, neutralState, { ready: true, data: response.data, meta: response.meta });
  },

  [types.CLEAR_PERSONAL_SCHEDULED_DATE_SCHEDULES_STORE](state) {
    assign(state, initState);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/personal/entities/personal-scheduled-date-schedules.js